"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetch = void 0;
var react_1 = require("react");
var context_1 = __importDefault(require("./context"));
function useFetch(fetcher) {
    var _a = (0, react_1.useState)({ loading: true, data: null, error: null }), fetchResult = _a[0], setFetchResult = _a[1];
    var SSRContext = (0, react_1.useContext)(context_1.default);
    var doFetch = function () {
        return fetcher(SSRContext._context)
            .then(function (data) {
            var result = { loading: false, data: data, error: null };
            setFetchResult(result);
            return result;
        })
            .catch(function (error) {
            var result = { loading: false, data: null, error: error === null || error === void 0 ? void 0 : error.toString() };
            setFetchResult(result);
            return result;
        });
    };
    (0, react_1.useMemo)(function () {
        var id = fetcher._id || "" + SSRContext.id++;
        var isServer = typeof window === 'undefined';
        if (isServer) {
            var pendingPromise = doFetch();
            SSRContext.fetcherCollector.register(id, pendingPromise);
        }
        else {
            var prefetchedData_1 = window.__SSR_FETCHED_DATA__[id];
            if (!prefetchedData_1) {
                doFetch();
            }
            else {
                Promise.resolve().then(function () {
                    setFetchResult(prefetchedData_1);
                });
            }
        }
    }, []);
    return fetchResult;
}
exports.useFetch = useFetch;
